module.exports = __webpack_public_path__ + "static/media/vr-cardboard.b85ddf3b.svg";